import React from "react";
import { useLocation } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import reduceChildRoutes from "./reduceChildRoutes";

const SidebarNavList = (props) => {
  const { pages, depth } = props;
  const router = useLocation();
  const currentRoute = router.pathname;
  const {
    user: { role },
  } = useAuth();

  const allowed = React.useCallback(
    (page) => {
      if (!page.allowed) return true;
      var success = page.allowed.map(function (val) {
        return role.indexOf(val) !== -1;
      });
      return success.includes(true);
    },
    [role]
  );

  const childRoutes = pages.reduce((items, page) => {
    const isAllowed = allowed(page);
    return reduceChildRoutes({ items, page, currentRoute, depth, isAllowed });
  }, []);

  return <React.Fragment>{childRoutes}</React.Fragment>;
};

export default SidebarNavList;
